import { FC, PropsWithChildren } from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import styles from './index.module.scss'
import { sanitizeUrl } from '../../../utils'

type Props = {
  backgroundText?: string
  href: string
  htmlTagType?: 'h1' | 'h2'
}

export const PrimaryHeadingWithLink: FC<PropsWithChildren<Props>> = ({
  children,
  backgroundText,
  href,
  htmlTagType = 'h1',
}) => {
  const className = classNames({
    [styles.container]: backgroundText,
    [styles.containerWithoutBackground]: !backgroundText,
  })

  if (htmlTagType === 'h1') {
    return (
      <div className={className}>
        {backgroundText && <span className={styles.backgroundText}>{backgroundText}</span>}
        <h1 className={styles.heading}>{children}</h1>
        <Link href={sanitizeUrl(href)}>
          <a className={styles.link}>View All →</a>
        </Link>
      </div>
    )
  }

  return (
    <div className={className}>
      {backgroundText && <span className={styles.backgroundText}>{backgroundText}</span>}
      <h2 className={styles.heading}>{children}</h2>
      <Link href={sanitizeUrl(href)}>
        <a className={styles.link}>View All →</a>
      </Link>
    </div>
  )
}
